import React from 'react';

var rowStyle = {
  marginBottom: 12,
  paddingBottom: 8,
  borderBottom: '3px solid #666',
  borderStyle: 'none none dashed none',
  clear: 'both'

}

var nameStyle = {
  float: 'right',
  backgroundColor: 'white',
  paddingLeft: '5px'
}

export default ({result}) =>
  <div style={rowStyle}>
    <span style={nameStyle}>{result.user.name}</span>
  </div>



// WEBPACK FOOTER //
// ./src/RollResults/LineBreakResult.js